module.exports = __webpack_public_path__ + "img/Klinisia.f53d5f93.svg";